
interface ScheduleStep2HeaderProps {
  psychologistName: string;
}

const ScheduleStep2Header = ({ psychologistName }: ScheduleStep2HeaderProps) => {
  return (
    <div>
      <h1 className="text-3xl font-bold">Escolha Data e Horário</h1>
      <p className="text-muted-foreground">
        Selecione o melhor dia e horário para sua consulta com {psychologistName}
      </p>
    </div>
  );
};

export default ScheduleStep2Header;
